import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Show up. Square up.",
    copy: "We do what we say, when we say it. Every anchor bolt, every rafter, every sheet set plumb, level, and true — checked twice before we roll off your jobsite.",
  },
  {
    num: "02",
    title: "Straight-shooting quotes.",
    copy: "No fog, no fine print. You get a clear number for a clearly specced building — and that number means something when we shake on it.",
  },
  {
    num: "03",
    title: "Built like our name's on the door.",
    copy: "Because it is. We treat your shop like our own shop: tight seams, clean details, and a jobsite left cleaner than we found it.",
  },
];

export const Manifesto = () => (
  <section id="why" data-testid="manifesto-section" className="border-t border-white/10 px-5 py-20 sm:px-8 lg:px-12 lg:py-28">
    <Reveal>
      <p className="text-[11px] font-medium uppercase tracking-[0.4em] text-turquoise">02 — Why Zeke</p>
      <h2 className="font-heading mt-4 max-w-3xl text-3xl font-black uppercase tracking-tight sm:text-4xl lg:text-5xl">
        The way building <span className="text-volt">used to be done</span>
      </h2>
    </Reveal>

    <div className="mt-16">
      {CHAPTERS.map((c, i) => (
        <Reveal key={c.num} delay={i * 0.1}>
          <div
            data-testid={`manifesto-chapter-${c.num}`}
            className="group grid grid-cols-1 gap-4 border-t border-white/10 py-10 transition-colors duration-500 last:border-b hover:bg-white/[0.02] md:grid-cols-12 md:items-baseline md:gap-8"
          >
            <span className="font-heading text-5xl font-black text-white/10 transition-colors duration-500 group-hover:text-volt/40 md:col-span-2 lg:text-6xl">
              {c.num}
            </span>
            <h3 className="font-heading text-2xl font-bold uppercase tracking-wide md:col-span-4">{c.title}</h3>
            <p className="max-w-xl text-sm leading-relaxed text-white/60 md:col-span-6">{c.copy}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
